import React, {FC} from 'react';

import Stack from '@mui/material/Stack';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import GeomaticoLink from '../../components/GeomaticoLink';
import Highlight from 'react-highlight';

const ScrollableContent = styled(Box)({
  overflow: 'auto',
  padding: '8px',
});

const stackSx = {
  height: '100%',
  overflow: 'hidden'
};

export type SidePanelContentProps = {
  mapStyle: string,
  onMapStyleChanged: (style: string) => void
};

const codeExample = `maplibregl.addProtocol('cog', cogProtocol);

const sources = {
  'hipsoSource': {
    type: 'raster',
    url: 'cog://https://cdn.geomatico.es/' +
      'pirineo_dem_cog_256.tif' +
      '#color:BrewerBrBG10,1300,2400,c-',
    tileSize: 256
  },
  'hillshadeSource': {
    type: 'raster-dem',
    url: 'cog://https://cdn.geomatico.es/' +
    'pirineo_dem_cog_256.tif#dem',
    tileSize: 256
  },
  'terrainSource': {
    type: 'raster-dem',
    url: 'cog://https://cdn.geomatico.es/' +
    'pirineo_dem_cog_256.tif#dem',
    tileSize: 256
  },
};

const layers = [{
  source: 'hipsoSource',
  id: 'imageLayer',
  type: 'raster'
},{
  source: 'hillshadeSource',
  id: 'hillshadingLayer',
  type: 'hillshade'
}];

const terrain = {
  source: 'terrainSource'
};`;

const SidePanelContent: FC<SidePanelContentProps> = () =>
  <Stack sx={stackSx}>
    <ScrollableContent>
      <h1>Same data, three usages</h1>
      <Highlight className="typescript">
        {codeExample}
      </Highlight>
    </ScrollableContent>
    <GeomaticoLink/>
  </Stack>;

export default SidePanelContent;
